import Dict from '@/utils/dict-utils'
import { companyTypeDict } from './company'

/**
 * 短信模板code，用于标识不同类型的短信验证码
 */
export const templateCodeDict = {
  transferManager: 'transfer_administrator_verification_code_sms',
  changeMobile: 'change_old_mobile_verification_code_sms',
  bindMobile: 'bind_mobile_verification_code_sms'
}

/**
 * 当前平台可开通的服务
 */
export const workbenchServiceDict = new Dict({
  PURCHASER: {
    value: 2,
    label: '采购人',
    desc: '发布企业自身采购或者招标项目',
    alias: 'purchaser',
    platformAlias: 'purchaser',
    certification: 'isPurchaser',
    iconName: 'purchaser',
    platform: 'ROLE_PURCHASER',
    companyType: [
      companyTypeDict.ENTERPRISE,
      companyTypeDict.PUBLIC_INSTITUTION
    ]
  },
  AGENCY: {
    value: 3,
    label: '代理机构',
    desc: '接受项目委托采购',
    alias: 'agency',
    platformAlias: 'agent',
    certification: 'isAgency',
    iconName: 'agency',
    platform: 'ROLE_AGENCY',
    companyType: [companyTypeDict.ENTERPRISE]
  },
  SUPPLIER: {
    value: 1,
    label: '供应商',
    desc: '参与投标报价',
    alias: 'supplier',
    platformAlias: 'supplier',
    certification: 'isSupplier',
    iconName: 'supplier',
    platform: 'ROLE_SUPPLIER',
    companyType: companyTypeDict.dictArray
  }
})

/**
 * 当前平台可以分配的权限（目前每一个权限对应一个工作台）
 * @type {Dict}
 * rightHidden: 为true表示无法被分配的权限
 * service: 当前权限，挂载在那个平台之下
 */
export const platformFunctionModuleDict = new Dict({
  PURCHASER_DEMAND: {
    funLabel: '采购需求',
    right: 'ROLE_PURCHASER_DEMAND',
    service: [workbenchServiceDict.PURCHASER.value]
  },

  PURCHASER: {
    funLabel: '招标采购', // 功能模块 label
    right: 'ROLE_PURCHASER',
    service: [workbenchServiceDict.PURCHASER.value]
  },

  AGENCY: {
    funLabel: '招标采购（代理）', // 功能模块 label
    right: 'ROLE_AGENCY',
    service: [workbenchServiceDict.AGENCY.value]
  },

  SUPPLIER: {
    funLabel: '投标报价',
    right: 'ROLE_SUPPLIER',
    service: [workbenchServiceDict.SUPPLIER.value]
  },

  FRAMEWORK_AGREEMENT: {
    funLabel: '供应商管理-框架协议',
    right: 'FRAMEWORK_AGREEMENT',
    service: [workbenchServiceDict.PURCHASER.value]
  },
  SUPPLIER_MANAGEMENT: {
    funLabel: '供应商管理',
    right: 'SUPPLIER_MANAGEMENT',
    service: [workbenchServiceDict.PURCHASER.value]
  },

  QUERY_STATS: {
    funLabel: '查询统计',
    right: 'ROLE_QUERY',
    service: [
      workbenchServiceDict.PURCHASER.value,
      workbenchServiceDict.AGENCY.value
    ]
  },

  FINANCIAL_MANAGEMENT: {
    funLabel: '财务管理',
    right: 'ROLE_FINANCE',
    service: [
      workbenchServiceDict.PURCHASER.value,
      workbenchServiceDict.AGENCY.value
    ]
  },

  EXPERT_MANAGEMENT: {
    funLabel: '专家管理',
    right: 'ROLE_EXPERT_MANAGEMENT',
    service: [
      workbenchServiceDict.PURCHASER.value,
      workbenchServiceDict.AGENCY.value
    ]
  },

  EXPERT_EXTRACTION: {
    funLabel: '专家抽取',
    right: 'ROLE_EXPERT_EXTRACTION',
    service: [
      workbenchServiceDict.PURCHASER.value,
      workbenchServiceDict.AGENCY.value
    ]
  },

  CA_MANAGEMENT: {
    funLabel: 'CA中心&会员',
    right: 'ROLE_CA_MANAGEMENT',
    service: [workbenchServiceDict.SUPPLIER.value]
  },

  SIGNATURE_MANAGEMENT: {
    funLabel: '在线签章',
    right: 'ROLE_SIGNATURE_MANAGEMENT',
    service: [workbenchServiceDict.SUPPLIER.value],
    rightHidden: true // 在线签章不能被分配，而是管理员在在线签章中添加员工
  },
  SIGNATURE_TASK: {
    funLabel: '签章任务',
    right: 'ROLE_SIGNATURE_TASK',
    service: [workbenchServiceDict.SUPPLIER.value],
    rightHidden: true // 签章任务不能被分配，而是管理员在在线签章中添加员工
  },

  RISK_GOVERNMENT: {
    funLabel: '风险治理',
    right: 'ROLE_RISK_GOVERNMENT',
    service: [workbenchServiceDict.PURCHASER.value]
  },

  // 该权限为管理员权限，无法分配
  BUSINESS_MANAGEMENT: {
    funLabel: '企业管理',
    right: 'ROLE_BUSINESS_MANAGEMENT',
    service: [
      workbenchServiceDict.PURCHASER.value,
      workbenchServiceDict.AGENCY.value,
      workbenchServiceDict.SUPPLIER.value
    ],
    rightHidden: true
  },

  // 该权限为默认权限，表示所有员工都有的权限，无法分配
  DEFAULT: {
    funLabel: '默认权限',
    right: 'ROLE_DEFAULT',
    service: [],
    rightHidden: true
  },

  // 五菱权限配置，开标管理员
  WL_OPEN_MANAGER: {
    funLabel: '开标管理',
    right: 'ROLE_WL_OPEN',
    service: [workbenchServiceDict.PURCHASER.value]
  },
  WL_TECH_REVIEW: {
    funLabel: '技术评审',
    right: 'ROLE_WL_REVIEW',
    service: [workbenchServiceDict.PURCHASER.value]
  },

  // 履约验收权限配置
  PROJECT_HANDING: {
    funLabel: '采购履约-指定项目经办人',
    right: 'ROLE_PROJECT_HANDING',
    service: [workbenchServiceDict.PURCHASER.value]
  },
  ENTRUST_HANDING: {
    funLabel: '采购履约-委托经办',
    right: 'ROLE_ENTRUST_HANDING',
    service: [workbenchServiceDict.AGENCY.value]
  }
})

// 文件是否需要鉴权下载
export const fileAuthorizationDict = new Dict({
  YES: { label: '需要', value: 1 },
  NO: { label: '不需要', value: 0 }
})

// 文件下载状态
export const fileDownloadStatusDict = new Dict({
  UN_DOWNLOAD: { label: '未下载', value: 1 },
  DOWNLOADING: { label: '下载中', value: 2 },
  SUCCESS: { label: '下载成功', value: 3 },
  FAIL: { label: '下载失败', value: 4 }
})

// 监管机构字典
export const superviseInstitutionDict = {
  JXGZW: { label: '江西国资委', value: 1 }
}

// 平台名称枚举
export const platformTitleDict = new Dict({
  JCZH: {
    label: '精彩纵横云采购平台',
    value: 1,
    portalUrl: process.env.VUE_APP_PORTAL_URL,
    alias: 'jczh',
    favicon: './favicon.ico'
  },
  GZ: {
    label: '江西省国有企业采购交易服务平台',
    value: 2,
    portalUrl: process.env.VUE_APP_PORTAL_GZ_URL,
    alias: 'gz',
    favicon: './undefined-favicon.ico'
  },
  XYGZ: {
    label: '新余市国有企业采购交易服务平台',
    value: 6,
    portalUrl: process.env.VUE_APP_PORTAL_XYGZ_URL,
    alias: 'xygz',
    favicon: './undefined-favicon.ico'
  },
  JXIC: {
    label: '江投集团电子采购平台',
    value: 3,
    portalUrl: process.env.VUE_APP_PORTAL_JXIC_URL,
    alias: 'jxic',
    favicon: './jxic-favicon.ico'
  },
  XIN_STEEL: {
    label: '新钢集团数字采购平台',
    value: 4,
    portalUrl: process.env.VUE_APP_PORTAL_XIN_STEEL_URL,
    alias: 'xin-steel',
    favicon: './xin-steel-favicon.ico'
  },
  GKJT: {
    label: '江西省港口集团电子采购平台',
    value: 5,
    portalUrl: process.env.VUE_APP_PORTAL_GKJT_URL,
    alias: 'gkjt',
    favicon: './gkjt-favicon.ico'
  },
  FZJJT: {
    label: '抚州市城市建设集团电子采购平台',
    value: 7,
    portal: process.env.VUE_APP_PORTAL_FZJJT_URL,
    alias: 'fzjjt',
    favicon: './fzjjt-favicon.ico'
  },
  STJT: {
    label: '江西水投集团电子采购平台',
    value: 8,
    portal: process.env.VUE_APP_PORTAL_STJT_URL,
    alias: 'stjt',
    favicon: './stjt-favicon.ico'
  }
})
